import { CircularProgress, Grid, Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import FiltersContext from '../../contexts/FiltersContext';
import StoryContext from '../../contexts/StoryContext';
import { displayFacilityType, composeWhereClause } from '../../modules/data';
import { rdsTabulate } from '../../modules/rds';
import states, { stateFIPS } from '../../modules/states';
import { toFormattedNumber } from '../../modules/text';
import MessageBox from '../MessageBox';
import ResponsiveContainer from '../ResponsiveContainer';
import StateMap from '../StateMap';

function LeadInfographic() {
  const { stateCode } = useParams();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [capacity, setCapacity] = useState(null);
  const { settingType, acceptSubsidies } = useContext(FiltersContext);
  const { primaryColor } = useContext(StoryContext);

  useEffect(() => {
    setReady(false);
    setError(null);

    function getCapacity() {
      let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]}`;
      whereClause += ' AND capacity_type=LIC AND is_near_high_risk_site=1';
      whereClause += composeWhereClause({ settingType });

      if (acceptSubsidies === 'Accept subsidies') {
        whereClause += ' AND is_subsidized=1';
      } else {
        whereClause += ' AND is_subsidized=0';
      }

      return rdsTabulate('ccdc', 'county_licensed_capacity', {
        dims: 'state',
        measure: 'capacity:SUM(capacity)',
        where: whereClause,
        format: 'amcharts',
      });
    }

    Promise.all([getCapacity()])
      .then((responses) => {
        setCapacity(responses[0].parsedBody.dataProvider[0].capacity);
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setReady(true);
      });
  }, [stateCode, settingType, acceptSubsidies]);

  if (!ready) {
    return (<CircularProgress />);
  }

  return (
    <Grid container spacing={2} justify="center">
      <Grid item xs={10} sm={6}>
        {error && <Typography variant="body1" align="center" color="error">{error.message}</Typography>}
        <MessageBox>
          <Typography variant="body1" align="left">
            In <b>{states[stateCode.toUpperCase()]}</b>, up to <b>{toFormattedNumber(capacity)}</b> children attend <b>{displayFacilityType(settingType).toLowerCase().replace('fcc', 'FCC')}</b> programs
            in high-risk locations and that <b>{acceptSubsidies.toLowerCase()}</b>.
          </Typography>
        </MessageBox>
      </Grid>
      <Grid item xs={12}>
        <ResponsiveContainer width="100%" aspect={3}>
          <StateMap stateCode={stateCode} color={primaryColor} />
        </ResponsiveContainer>
      </Grid>
    </Grid>
  );
}

export default LeadInfographic;
